import React, { lazy, Suspense } from 'react';
import ReactDOM from "react-dom/client";
import { Provider } from 'react-redux';
import { AppDispatch, store } from './app/store';
import reportWebVitals from './reportWebVitals';
import { AppLayout, AuthLayout } from './App';
import { Contact } from './components/Disclaimer';
import { ResourceLanding } from "./components/resources/ResourceLanding";
import { createBrowserRouter, RouterProvider, Navigate } from "react-router-dom";
import Loadash from 'lodash';
import { SignoutResponse, User, UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts';
import awsconfig from './aws-exports';
import { initializeAppMetadata } from './index-util';
import { AuthProviderWithRef } from './app/components/AuthProviderWithRef';
import { ClinicalTrialsInfo } from './components/massive-bio/ClinicalTrialsInfo';
import { utilityApi } from './features/utilitySlice';
import { getVersion } from './app/hooks';

import { Log } from 'oidc-client-ts'; // Import Log
import { ChatScopeUseChatConversations } from './components/messaging/ChatScopeUseChat';
import { MagicLinkGuard } from './MagicLinkGuard';
import { MainSignIn } from './components/iam/MainSignIn';
import { navigateRef, RootLayout } from './RootLayout';
import { AppBody } from './AppBody';
import Event2026Preview from './components/sms-link-pages/Event2026Preview';

import { BCAN_Trials } from './poc/bcan_clinical_trials/bcan_trials';
import { AuthBootstrapProvider } from './AuthBootstrapProvider';
import EventPreview from './components/sms-link-pages/EventKindness';

import { HealthWalletMain } from './components/healthwallet/HealthWalletMain';
import TheoryPreview from './components/sms-link-pages/TheoryPreview';
import ShinglesPreview from './components/sms-link-pages/ShinglesPreview';
import FluPreview from './components/sms-link-pages/FluPreview';


if ((process.env.NODE_ENV || 'development') !== 'production') {
  // Production-specific code (e.g., analytics)
  Log.setLogger(console); // Directs logs to the browser's console
  Log.setLevel(Log.DEBUG); // Set the logging level to DEBUG
}

const PrivacyPolicyComponent = lazy(() => import('./components/massive-bio/Privacy1').then(module => ({ default: module.PrivacyPolicyComponent })));
const HipaaConsentComponent = lazy(() => import('./components/massive-bio/HIPAA').then(module => ({ default: module.HipaaConsentComponent })));
const MassiveBioTermsAndConditions = lazy(() => import('./components/massive-bio/TermsAndConditions').then(module => ({ default: module.MassiveBioTermsAndConditions })));

// Restore the capitalizeWords function
export const capitalizeWords = (input: string): string => {
  return Loadash.words(input).map(Loadash.capitalize).join(' ');
};

const container = document.getElementById('root')!;
const root = ReactDOM.createRoot(container);
// Capture the original URL at module load — before MagicLinkGuard, before
// any navigate/replaceState, before oidc-client-ts processing — so deep-link
// params (e.g. ?conversationId=) survive whatever happens downstream.
export const INITIAL_URL_SEARCH = window.location.search;
export const INITIAL_URL_PARAMS = new URLSearchParams(INITIAL_URL_SEARCH);
export var baseName = (window.location.pathname.split("/")[2] ?? '').toLowerCase();
export interface Condition { condition: string, baseName: string }

export const allConditions = ["Juvenile Myositis", "Multiple Myeloma", "Heart Failure", "Children's Cardiomyopathy", "Bladder Cancer", "Adult Myositis"]
export const showSupergroups: boolean = false

const conditionTemp = baseName ? capitalizeWords(baseName.replaceAll("-", " ").replaceAll('hildrens', "hildren's")) : 'Multiple Myeloma'
export var condition: string
if (allConditions.includes(conditionTemp)) {
  condition = conditionTemp
} else {
  condition = 'Multiple Myeloma'
  baseName = ''
}
export const coonditionContext = React.createContext<Condition>({ condition: "Multiple Myeloma", baseName: '' });

const onSigninCallback = (_user: User | void): void => {
  //const nestedPath = (_user?.state as any)?.nestedPath
  //console.log(`$$$$$$$$$$$$$$$$$$$$$$$$$!!!!!!!!!!!>>>>>>>>>>onSigninCallback<<<<<<<<<!!!!!!!!$$$$$$$$$$$$$$$$$$$$$`, _user?.state)
  const params = new URLSearchParams(window.location.search);
  const entries = Array.from(params.entries());

  const parmString = entries.map(([key, value]) => `${key}=${value}`).join(', ');
  (store.dispatch as AppDispatch)(
    utilityApi.endpoints.logToBackEnd.initiate({
      context: 'onSigninCallback',
      message: parmString,
      version: getVersion(),
    })
  );

  if (_user) {
    // encode & remove phooneNumberToLink from user.state since  and REDIRECT  with ?phone= parm
    const phooneNumberToLink = (_user.state as any).phooneNumberToLink
    if (phooneNumberToLink) {
      const phooneNumberToLinkEncoded = encodeURIComponent(phooneNumberToLink)
      window.history.replaceState(
        {},
        document.title,
        `${window.location.pathname}?phone=${phooneNumberToLinkEncoded}`
      )
      return
    }
  }
  //Navigate to the rounte in user.state from auth
  if (_user) {
    const routeNavigate = (_user.state as any).route
    if (routeNavigate) {
      if (navigateRef) {
        navigateRef(routeNavigate)
      }
      return
    }
  }

  //HERE could call dispatch(setSessionForRTK({ newSession, authMethod: HOSTED_UI_REDIRECT }))
  // dispatch(setAuthenticated(true))
  // BUT need to call profile from db before setting these so do this in use Effect in useAuthBootsrap

  /////////////clear OAuth route parms only — preserve other query params (e.g. ?conversationId=)
  // so deep links survive the Cognito sign-in callback.
  const cleanedParams = new URLSearchParams(window.location.search);
  ['code', 'state', 'scope', 'session_state', 'error', 'error_description', 't'].forEach(p => cleanedParams.delete(p));
  const cleanedSearch = cleanedParams.toString();
  window.history.replaceState(
    {},
    document.title,
    `${window.location.pathname}${cleanedSearch ? `?${cleanedSearch}` : ''}`
  )

}


const matchSignoutCallback: (args: UserManagerSettings) => boolean = (args) => {
  return window && (window.location.href === args?.post_logout_redirect_uri);
}

const onSignoutCallback = (resp: SignoutResponse | undefined): void => {
  // go to home after logout
  //console.log(`!!!!!!!!!!!!!!!!!!!${resp?.state}!!!!!!!!!!!!!`)
  //console.log('onSignoutCallback', resp)
  //window.location.pathname = ""
}


export const getAwsConfig: (baseName: string) => any = (baseName) => {
  const redirectSignIn1 = awsconfig.redirect_uri.replace('/callback', `${baseName ? `/${baseName}` : ''}/callback`)
  const redirectSignOut1 = awsconfig.post_logout_redirect_uri.replace('/out', `${baseName ? `/${baseName}` : ''}/out`)
  const deepCopy = JSON.parse(JSON.stringify(awsconfig));
  deepCopy.redirect_uri = redirectSignIn1
  deepCopy.post_logout_redirect_uri = redirectSignOut1
  deepCopy.silent_redirect_uri = redirectSignOut1
  deepCopy.onSigninCallback = onSigninCallback
  deepCopy.matchSignoutCallback = matchSignoutCallback
  deepCopy.onSignoutCallback = onSignoutCallback
  deepCopy.userStore = new WebStorageStateStore({ store: window.localStorage })
  deepCopy.automaticSilentRenew = true
  //deepCopy.userStore =  new BackEndUserStore()//CookieUserStore()      
  return deepCopy
}
export const cognitoAuthConfig: () => any = () => getAwsConfig(baseName)

const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <RootLayout />, // always rendered
      children: [
        // ---- Guarded routes ----
        {
          element: <MagicLinkGuard />, // runs on all children below
          children: [
            {
              element: <AppLayout />,
              children: [
                { index: true, element: <AppBody /> },
                { path: "callback", element: <AppBody />, handle: { callback: true } },
                { path: "out", element: <AppBody />, handle: { out: true } },
                { path: "nb", element: <AppBody />, handle: { nb: true } },
                { path: "DataDeletionInstructions", element: <AppBody />, handle: { dataDeletionInstructions: true } },
                { path: "Delete-Profile", element: <AppBody />, handle: { DeleteProfile: true } },
                { path: "bcanstudy", element: <AppBody />, handle: { noBanner: true, bcanStudy: true } }, // BCAN study landing — map with the research banner suppressed; flags the HW Merck-study consent default
                { path: "researchconnect", element: <AppBody />, handle: { researchConnect: true } }, // Research Connect Direct landing — flags the HW RCD consent default. Non-BC maps only (enforced in OnboardingConsent, not here)
                //{ path: "ResourceGrid", element: <LinkGrid /> },
                { path: "Resources", element: <ResourceLanding />, handle: { scrollable: true } },
                { path: "KnowledgeConnect", element: <Navigate to="/Resources" replace /> },
                { path: "sign-up-for-clinical-trials", element: <ClinicalTrialsInfo />, handle: { scrollable: true } },
                {
                  path: "massivebio-privacy-policy", element: (
                    <Suspense fallback={<div>Loading Privacy Policy...</div>}>
                      <PrivacyPolicyComponent />
                    </Suspense>
                  )
                },
                {
                  path: "massivebio-hipaa", element: (
                    <Suspense fallback={<div>Loading HIPAA Information...</div>}>
                      <HipaaConsentComponent />
                    </Suspense>
                  )
                },
                {
                  path: "massivebio-terms-and-conditions", element: (
                    <Suspense fallback={<div>Loading Terms and Conditions...</div>}>
                      <MassiveBioTermsAndConditions />
                    </Suspense>
                  )
                },
                { path: "SignInToDeleteProfile", element: <AppBody />, handle: { DeleteProfile: true } },
                { path: "Profile", element: <AppBody />, handle: { showProfileFromUrl: true } },
                { path: "Contact", element: <Contact />, handle: { scrollable: true } },
                { path: "support", element: <Navigate to="/Contact" replace /> },
                { path: "event2026", element: <Event2026Preview /> },
                { path: "kindness", element: <EventPreview imageUrl = "/map/preview/kindness/image.jpg"/> },
                { path: "theory", element: <TheoryPreview imageUrl="/map/preview/theory/image.jpg" pdfUrl="/map/preview/theory/Multiple Myeloma Diagnosis Theory Analysis.pdf" pdfName="Multiple Myeloma Diagnosis Theory Analysis.pdf" /> },
                { path: "shingles", element: <ShinglesPreview imageUrl="/map/preview/shingles/image.jpg" /> },
                { path: "flu", element: <FluPreview imageUrl="/map/preview/flu/image.jpg" /> },
                 // <-- Catch-all for unknown routes -->
                //{ path: "*", element: <Navigate to="/" replace /> },
                { path: "View", element: <Navigate to="/" replace /> },
              ],
            },
            // ---- Conversations route ----
            { path: "Conversations", element: <ChatScopeUseChatConversations /> },
            { path: "HealthWallet", element: <HealthWalletMain />, handle: { scrollable: true } },
            { path: "health-wallet", element: <Navigate to="/HealthWallet" replace />, },
            {
              path: "HealthWallet/:resource/:name/*",
              element: <HealthWalletMain />,
              handle: { scrollable: true },
            },
          ],
        },
        // ---- Auth routes (unguarded) ----
        {
          element: <AuthLayout />,
          children: [
            { path: "SignIn", element: <MainSignIn /> },
            { path: "SignInToMap", element: <MainSignIn navigateTo='/' /> }, //forces removarl or the t query parm extraction/attachment of phone number on federated login
            { path: "smsLogin", element: <MainSignIn showSMSLoginAtStart={true} /> },
            { path: "BCAN_Trials", element: <BCAN_Trials /> },
          ],
        },
      ],
    },
  ],
  { basename: `/map${baseName ? `/${baseName}` : ""}` }
);


initializeAppMetadata(baseName, condition)

root.render(
  // 1. Redux Provider (for useAuthProfile/useSelector)
  <Provider store={store}>
    {/* 2. RouterProvider renders RootLayout, starting the entire app tree */}
    <AuthProviderWithRef {...cognitoAuthConfig()}>
      <AuthBootstrapProvider>
        <RouterProvider router={router} />
      </AuthBootstrapProvider>
    </AuthProviderWithRef>
  </Provider>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals(console.log);
